import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { HeartHandshake, Loader2, AlertCircle, ArrowLeft, Users } from 'lucide-react';

const pub = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api' });

const fmt = (n) =>
  Number(n || 0).toLocaleString('nb-NO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

const STIL = {
  side: { minHeight: '100vh', background: '#f5f7fb', padding: '24px 16px', fontFamily: 'system-ui, sans-serif' },
  wrap: { maxWidth: 720, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 16 },
  kort: { background: '#fff', borderRadius: 16, padding: 24, boxShadow: '0 4px 20px rgba(0,0,0,0.05)' },
  hero: { background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', color: '#fff', borderRadius: 16, padding: 28, position: 'relative', overflow: 'hidden' },
  btn: { padding: '12px 18px', borderRadius: 10, border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 15 },
  bar: { height: 10, background: 'rgba(255,255,255,0.25)', borderRadius: 5, overflow: 'hidden' },
  barIn: { height: '100%', background: '#fff', borderRadius: 5, transition: 'width .5s ease' },
  tilbake: { display: 'inline-flex', alignItems: 'center', gap: 6, color: '#6b7280', textDecoration: 'none', fontSize: 14 },
};

const GiversideTeam = () => {
  const { slug, teamSlug } = useParams();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [feil, setFeil] = useState(null);

  const last = useCallback(async () => {
    try {
      const r = await pub.get(`/public/kampanje/${slug}/team/${teamSlug}`);
      setData(r.data);
    } catch (e) {
      setFeil(e?.response?.data?.error || 'Fant ikke teamet.');
    }
  }, [slug, teamSlug]);

  useEffect(() => { last(); }, [last]);

  if (feil) {
    return (
      <div style={STIL.side}>
        <div style={STIL.wrap}>
          <div style={{ ...STIL.kort, textAlign: 'center' }}>
            <AlertCircle size={48} color="#ef4444" style={{ margin: '0 auto 12px' }} />
            <h2>Team ikke funnet</h2>
            <p style={{ color: '#6b7280' }}>{feil}</p>
            <a href={`/gi/${slug}`} style={STIL.tilbake}>
              <ArrowLeft size={14} /> Til hovedkampanjen
            </a>
          </div>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div style={STIL.side}>
        <div style={STIL.wrap}>
          <div style={{ ...STIL.kort, textAlign: 'center' }}>
            <Loader2 size={32} className="spin" />
            <p>Laster …</p>
          </div>
        </div>
      </div>
    );
  }

  const t = data.team;
  const prog = t.mal_belop > 0 ? Math.min(100, (t.samlet_belop / t.mal_belop) * 100) : 0;

  return (
    <div style={STIL.side}>
      <div style={STIL.wrap}>
        <a href={`/gi/${slug}`} style={STIL.tilbake}>
          <ArrowLeft size={14} /> Tilbake til {data.kampanje.tittel}
        </a>

        <div style={STIL.hero}>
          {t.bilde_url && (
            <img src={t.bilde_url} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.25 }} />
          )}
          <div style={{ position: 'relative' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
              <Users size={26} />
              <span style={{ opacity: 0.9, fontSize: 13 }}>Team i kampanjen {data.kampanje.tittel}</span>
            </div>
            <h1 style={{ margin: '0 0 8px', fontSize: 28 }}>{t.navn}</h1>
            {t.eier_navn && <p style={{ opacity: 0.95, margin: '0 0 8px' }}>Drives av {t.eier_navn}</p>}
            {t.beskrivelse && <p style={{ opacity: 0.95, lineHeight: 1.5 }}>{t.beskrivelse}</p>}
            {t.mal_belop > 0 && (
              <div style={{ marginTop: 16 }}>
                <div style={STIL.bar}>
                  <div style={{ ...STIL.barIn, width: `${prog}%` }} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8, fontSize: 14 }}>
                  <span><b>{fmt(t.samlet_belop)} kr</b> samlet inn</span>
                  <span>Mål: {fmt(t.mal_belop)} kr</span>
                </div>
              </div>
            )}
            {!t.mal_belop && (
              <p style={{ marginTop: 12, fontSize: 14 }}>
                Samlet inn: <b>{fmt(t.samlet_belop)} kr</b>
              </p>
            )}
          </div>
        </div>

        <div style={{ ...STIL.kort, textAlign: 'center' }}>
          <HeartHandshake size={32} color="#10b981" style={{ margin: '0 auto 8px' }} />
          <h3 style={{ marginTop: 0 }}>Støtt {t.navn}</h3>
          <p style={{ color: '#6b7280' }}>Din donasjon registreres på dette teamet.</p>
          <button
            style={{ ...STIL.btn, background: '#10b981', color: '#fff' }}
            onClick={() => nav(`/gi/${slug}?team=${t.id}`)}
          >
            Gi gjennom dette teamet
          </button>
        </div>

        <p style={{ textAlign: 'center', fontSize: 12, color: '#9ca3af' }}>
          Drives av REGNINO.
        </p>
      </div>
    </div>
  );
};

export default GiversideTeam;
